import { useCreateWorkOrderComplement } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { useWorkorderForms } from '../../WorkOrderFormProvider';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const ComplementCreateButton: React.FC = () => {
  const history = useHistory();
  const { forms } = useWorkorderForms();

  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const createComplemente = useCreateWorkOrderComplement();

  async function handleCreateComplement() {
    try {
      await forms.generalInfo?.validateFields();

      if (workorder && complement) {
        const result = await createComplemente.mutateAsync({
          workOrderId: workorder.id,
          complementId: complement.id,
          customerType: complement.customerType,
          type: complement.type,
          insurerId: complement.insurer?.id,
          accidentNumber: complement.accidentNumber,
          insurerDeductibleAmount: complement.insurerDeductibleAmount,
          prisma: complement.prisma,
          currentKilometers: complement.currentKilometers,
          tankLevel: complement.tankLevel,
          entryDate: complement.entryDate,
          estimatedLeaveDate: complement.estimatedLeaveDate,
        });

        history.push(
          `/app/movements/workOrders/${workorder.id}/complements/${result.id}/generalInfo`,
        );
      }
    } catch {}
  }

  return (
    <Button
      onClick={handleCreateComplement}
      block
      loading={createComplemente.isLoading}
      disabled={
        workorder?.isPortoBatteryWorkOrder ||
        !hasPermissions([Authorities.MOVIMENTATION_WORKORDER_ADD_COMPLEMENT])
      }
    >
      <FormattedMessage id="workOrders.details.createComplement" />
    </Button>
  );
};

export default ComplementCreateButton;
